module.exports = __webpack_public_path__ + "static/media/404-cake.9242bd7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404/404-cake.svg
// module id = 2073
// module chunks = 43